import {getStore} from '@/store/StoreInstance';
import {removeCookie} from '@/util/cookies.js';

function getJwtTokenFromUrl() {
	const queryString = window.location.search;
	const params = new URLSearchParams(queryString);
	return params.get('ticket');
}

function resetJwtCookie() {
	removeCookie('jwt');
	getStore().commit('setJWT', null);
}

function isJwtExpired() {
	let expTime = getStore().state?.jwt?.exp;
	if (!expTime) return true;
	const isExpired = expTime * 1000 < new Date().getTime();
	if (isExpired) resetJwtCookie();
	return isExpired;
}

export {getJwtTokenFromUrl, resetJwtCookie, isJwtExpired};
